import React, { useState } from "react";
import { uri } from "../../../../../help/Api";
import useFetchObjectByPost from "../../../../../components/Hooks/useFetchObjectByPost";
import { insh, sto } from "../../../../../Context/InshData";
import BackdropScI from "../../../../../services/BackdropScI";
import IReceiptVoucher from "./IReceiptVoucher";

import useFetchURL from "../../../../../components/Hooks/useFetchURL";
import { accountsURL } from '../../../../../api/IReceipt';
import { useEffect } from "react";
import dataF from "../../../../../Server/dataF.json"
import { useTranslation } from "react-i18next";

function getReFormatingAccount(data){

    const newData = data.map((row, i)=> {
            return {id: row.id,
                 name:row.symbol,
                 code: row.barcode,
                } 
        })
    return newData
}

function ReceiptVoucherItem(props){
  const { t } = useTranslation(["forms"]);
  const [branch, setBranch] = useState({ id: -1, name: t("all") });
  const tb = {
    wait: true,
    Branch: true,
    stor: { ...sto, branchi: branch.id == -1 ? sto.branchi : branch.id },
    parms: { 
        branch: branch.id == -1 ? sto.branchi : branch.id ,
        iempid: sto.empi,
     },

  };

  const { object: AutoOptionsB, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb,
    [branch]
  );
   const requestData ={
    /*other:true,*/ // out
    wait:true,
    other:true,
    Users:true,
    Stocks:true, // Error // out
    Banks:true,
    AccountBooks: true,
    // salesmen:true,
    costcenters:true,
    // Employees:true,
    CheckStatus:true,
    PermissionsElemnts:true,
    /*params*/ // out
    parms:{
      ibranchid: branch.id == -1 ? sto.branchi : branch.id, 
      iempid: sto.empi,
      iuserid: sto.idi, 
      icustmtype: 1,
      scurrenciestype: 'I',
      branch:branch.id == -1 ? sto.branchi : branch.id,
      tname:"sandqd",
      iformid: dataF[68].id,
    },
    autos:{
      AccountBooks: true,
      Users:true,
      Safes:true,
      Stocks:true,
      Banks:true,
      // Employees:true,
    //   salesmens:true,
      costcenters: true,
      CheckStatus: true,
    }
  }

    const url = uri+'Res';

    const {object:AutoOptions, fetching: fetchinData, fetch:fetchURL} =
      useFetchObjectByPost(url, requestData, [branch]);
    const {data, fetching, fetchURL: fetchURL1} = useFetchURL({...{
      url: accountsURL,
      mapFunction: getReFormatingAccount,
    }})
    // useEffect(()=>{
    //   console.log('the data is', data);
    // })
      if(fetchinData || !data || fetching || !AutoOptions.Stocks ||!AutoOptionsB?.Branches)
        return <BackdropScI />
    return (
      // <div></div>
        <IReceiptVoucher
        {...{
            AutoOptions: AutoOptions?.Users? {...AutoOptions, Customers: data}: [],
            fetchURL,
            prmis: AutoOptions?.permisElm?? insh.permiElm, 
            ...props,
            AutoOptionsB: AutoOptionsB?.Branches? AutoOptionsB: [],
            branch,
            setBranch,
        }}/>
    )
}


export default function IReceiptVoucherCon(){

    return (
      
        <ReceiptVoucherItem
        {...{
          isDialog: false,
          isDialogData: false,
    
        }}/>
    )
}

export function IReceiptVoucherLink(props){
  const {data: item, onClose,} = props;

    return (
        <ReceiptVoucherItem
        {...{
            isDialog: true,
            item,
            onClose,
            isDialogData: false,
        }}/>
    )
}

   